module.exports = __webpack_public_path__ + "static/media/p_17_3.15364cbc.png";